import http from 'apis/config/http-service';
import { useCallback } from 'react';

// Async search for the Add SOA modal's supplier picker (ChakraAsyncSelect) —
// same pattern as useSearchQuotationSuppliersApi (src/apis/restaurant-inquiries/use-quotation-suppliers-api.ts),
// the inquiries flow's supplier dropdown. Hits the supplier-profiles list
// (not a generic suppliers search) because only profiles linked to a supplier
// are reconcilable.
const endpoint = 'api/v1/cms/supplier-profiles';

export interface ReconciliationSupplierOption {
  value: number; // supplierId (NOT the profile id)
  label: string;
}

interface SupplierProfileRow {
  businessName: string;
  supplierId: number | null;
  supplier: { id: number; name: string | null } | null;
}

export function useSearchReconciliationSuppliersApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: ReconciliationSupplierOption[]) => void) => {
    http
      .get(endpoint, {
        params: { page: 1, limit: 20, name: inputValue || undefined },
      })
      .then(({ data }) => {
        const list: SupplierProfileRow[] = data?.data ?? [];
        callback(
          list
            // Only linked profiles are reconcilable — an unlinked profile has no supplier to bill.
            .filter((row) => row.supplierId !== null)
            .map((row) => ({
              value: row.supplierId as number,
              label: row.supplier?.name || row.businessName || `Supplier #${row.supplierId}`,
            }))
        );
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
